module.exports = "/_next/static/images/StreamlineCompliance@3x-105fd68b3225fa45165f75457279c236.webp";